import Vue from "vue";
import Vuex from "vuex";

import menu from "~/store/menu";
import prova from "~/store/prova";
import monitorAlunos from "~/store/monitorAlunos";

Vue.use(Vuex);

function initialState() {
  return {
    token: null,
    usuario: {
      nome: "Usuário teste"
    },
    grupoConteudo: {
      id: null,
      nome: ""
    },
    timer: {
      timeLimit: null,
      timeLeft: null,
      dateTimeLimit: null,
      extraTime: null
    },
    identidadesVisuais: {
      applicado: {
        name: "Applicado",
        css: "/static/css/applicado.css",
        logoHorizontal: "/static/images/applicado-horizontal.svg",
        logoVertical: "/static/images/applicado-vertical.svg"
      },
      pazzei: {
        name: "Pazzei",
        css: "/static/css/pazzei.css",
        logoHorizontal: "/static/images/pazzei-horizontal.svg",
        logoVertical: "/static/images/pazzei-vertical.svg"
      }
    },
    identidadeVisual: {
      name: "Applicado",
      css: "/static/css/applicado.css",
      logoHorizontal: "/static/images/applicado-horizontal.svg",
      logoVertical: "/static/images/applicado-vertical.svg"
    },
    envioBloqueado: false,
    defaultRoute: null,
    acessoVerificado: false,
    lembrar: true,
    infoPage: {
      title: "",
      description: "",
      button: {}
    }
  };
}

const mutations = {
  updateTimer(state, { timeLimit, timeLeft, dateTimeLimit, extraTime }) {
    state.timer = { timeLimit, timeLeft, dateTimeLimit, extraTime };
  },
  updateEnvioBloqueado(state, envioBloqueado) {
    state.envioBloqueado = envioBloqueado;
  },
  updateToken(state, token) {
    state.token = token;
  },
  updateUsuario(state, usuario) {
    state.usuario = usuario;
  },
  updateAcessoVerificado(state, acessoVerificado) {
    state.acessoVerificado = acessoVerificado;
  },
  updateLembrar(state, lembrar) {
    state.lembrar = lembrar;
  },
  updateLogo(state, logo) {
    state.logo = logo;
  },
  updateInfoPage(state, infoPage) {
    state.infoPage = infoPage;
  },
  updateGrupoConteudo(state, grupoConteudo) {
    state.grupoConteudo = grupoConteudo;
  },
  updateDefaultRoute(state, defaultRoute) {
    state.defaultRoute = defaultRoute;
  },
  updateIdentidadeVisual(state, identidadeVisual) {
    state.identidadeVisual = identidadeVisual;
  },
  clearStorage(state) {
    const s = initialState();

    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  initialiseStore(state) {
    if (localStorage.getItem("store")) {
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem("store")))
      );
    }
  }
};

const actions = {
  setTimer(state, { timeLimit, timeLeft, dateTimeLimit, extraTime }) {
    state.commit("updateTimer", {
      timeLimit,
      timeLeft,
      dateTimeLimit,
      extraTime
    });
  },
  setEnvioBloqueado(state, envioBloqueado) {
    state.commit("updateEnvioBloqueado", envioBloqueado);
  },
  clearTimer(state) {
    state.commit("updateTimer", {
      timeLimit: null,
      dateTimeLimit: null
    });

    state.commit("updateEnvioBloqueado", false);
  },
  setToken(state, token) {
    state.commit("updateToken", token);
  },
  setUsuario(state, usuario) {
    state.commit("updateUsuario", usuario);
  },
  setAcessoVerificado(state, acessoVerificado) {
    state.commit("updateAcessoVerificado", acessoVerificado);
  },
  setLembrar(state, lembrar) {
    state.commit("updateLembrar", lembrar);
  },
  setInfoPage(state, infoPage) {
    state.commit("updateInfoPage", infoPage);
  },
  setGrupoConteudo(state, grupoConteudo) {
    state.commit("updateGrupoConteudo", grupoConteudo);
  },
  setDefaultRoute(state, defaultRoute) {
    state.commit("updateDefaultRoute", defaultRoute);
  },
  setIdentidadeVisual(state, identidadeVisual) {
    state.commit("updateIdentidadeVisual", identidadeVisual);
  },
  clearStorage(state) {
    state.commit("clearStorage");
  }
};

const store = new Vuex.Store({
  state: initialState(),
  actions,
  mutations,
  modules: { menu, prova, monitorAlunos }
});

store.subscribe((mutation, state) => {
  const badMutations = [];

  if (badMutations.indexOf(mutation.type) === -1) {
    localStorage.setItem("store", JSON.stringify(state));
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js